import app from 'app';
import Marionette from 'backbone.marionette';

app.namespace.Controller.VideoController = Marionette.Object.extend({
  connectToFaceBook(videoModel) {
    console.log('connectToFaceBook Start !! ' + videoModel.videoPath);
    return app.api.socialProvider.connect(
      videoModel,
      app.api.socialProvider.providers.FACEBOOK
    );
  },

  uploadToFaceBook(videoModel, title, description, targetId) {
    console.log('uploadToFaceBook Start !! ' + videoModel.get('videoPath'));
    return app.api.socialProvider.uploadVideoModel(
      videoModel,
      app.api.socialProvider.providers.FACEBOOK,
      title,
      description,
      null, // privacyStatus
      targetId
    );
  },

  connectToYoutube(videoModel) {
    console.log('connectToYoutube Start !! ' + videoModel.videoPath);
    return app.api.socialProvider.connect(
      videoModel,
      app.api.socialProvider.providers.YOUTUBE
    );
  },

  uploadToYoutube(videoModel, title, description, privacyStatus) {
    console.log('uploadToYoutube Start !! ' + videoModel.videoPath);
    return app.api.socialProvider.uploadVideoModel(
      videoModel,
      app.api.socialProvider.providers.YOUTUBE,
      title,
      description,
      privacyStatus
    );
  },

  connectToTwitter(videoModel) {
    console.log('connectToTwitter Start !! ' + videoModel.videoPath);
    return app.api.socialProvider.connect(
      videoModel,
      app.api.socialProvider.providers.TWITTER
    );
  },

  /**
   * upload succeeds if video filesize is up to 15MB and duration is up to 30s.
   */
  uploadToTwitter(videoModel, title, description) {
    console.log('uploadToTwitter Start !! ' + videoModel.videoPath);
    return app.api.socialProvider.uploadVideoModel(
      videoModel,
      app.api.socialProvider.providers.TWITTER,
      title,
      description
    );
  },
});
